// FROM: https://www.pluralsight.com/guides/using-react's-context-api-with-typescript
import React, { createContext, useContext, useState } from "react";
import { BookingContextType, Booking } from "../models/models";
import { transitionDurationSpinners } from "./Settings";
import { Backdrop, CircularProgress } from "@material-ui/core";

// CREATE THE BOOKING CONTEXT WITH DEFAULT VALUES
export const BookingContext = createContext<BookingContextType>({ booking: {} as Booking, setBooking: booking => console.warn("no booking provider"), loading: true, setLoading: loading => console.warn("no loading") });

// METHOD FOR RETRIEVING BOOKING CONTEXT
export const useBooking = () => useContext(BookingContext);

// BOOKING CONTEXT PROVIDER WHICH WRAPS OUR BOOKING PROCESS PAGES
export function BookingContextProvider(props: { children: React.ReactNode }) {
	const currentBooking = JSON.parse(window.sessionStorage.getItem("booking") ?? "{}");
	const [booking, setBooking] = useState(currentBooking);	// GLOBAL STATE USED TO GET/SET BOOKING OBJECT
	const [loading, setLoading] = useState(true);

	return (
		<BookingContext.Provider value={{ booking, setBooking, loading, setLoading }}>
			{props.children}
			<Backdrop open={loading} transitionDuration={{ enter: transitionDurationSpinners }}>
				<CircularProgress color="secondary" />
			</Backdrop>
		</BookingContext.Provider>
	);
}